<template>
  <div>
    <div class="col-sm-12 card">
      <div class="card-header">
        <h4 class="card-title">
          {{ inflow ? "Your" : "Credit" }} Order
          <span v-if="!inflow && credit" class="btn pull-right">Current Credit: {{ credit }}</span>
        </h4>
        <div v-if="inflow" class="category">
          Review your order
          {{ nothingToPay ? "" : "and pay using a credit or debit card below" }}
        </div>
        <div v-else class="category">
          Buy credit for your requests using a credit or debit card below
        </div>
      </div>

      <div v-loading="loading || paying" element-loading-spinner="qc-spinner" class="card-content row">
        <el-table class="table table-striped table-no-bordered" ref="paymentTable" :data="items" style="width: 100%"
          tooltip-effect="light">
          <el-table-column :min-width="300" :show-overflow-tooltip="true" label="Item">
            <template slot-scope="props">
              <span v-if="props.row.another">
                <button @click.prevent="$emit('newVerification')" type="button" class="btn btn-wd">
                  <i class="fa fa-plus"></i> Add another verification
                </button>
              </span>
              <span v-else-if="props.row.exact">
                {{ props.row.name }}
              </span>
              <span v-else-if="props.row.app">
                <div>
                  <strong>{{ props.row.name }}</strong>
                </div>
                {{ props.row.owner }}
              </span>
              <span v-else-if="!props.row.calc">
                <div>
                  <div>
                    <strong>{{ props.row.candidateName }}</strong>
                  </div>
                  <div v-for="name in props.row.instituteNames">
                    {{ name.name }}
                  </div>
                </div>
              </span>
            </template>
          </el-table-column>
          <el-table-column :width="40">
            <template slot-scope="props">
              <span v-if="!props.row.calc && !props.row.another && !props.row.app">
                <a v-if="!multi && !inview" class="btn btn-simple btn-info btn-xs btn-icon btn-warning" @click.prevent="$emit('editVerification', verifications[props.$index])"><i class="fa fa-pencil"></i></a>
                <a v-if="canRemove && verifications.length > 1"
                  class="btn btn-simple btn-info btn-xs btn-icon btn-danger"
                  @click.prevent="$emit('deleteVerification', props.$index)"><i class="fa fa-trash"></i></a>
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="inflow ? 'Our Price' : ''" :width="150" align="right">
            <template slot-scope="props">
              <div v-if="props.row.oldFee != null">
                <span v-if="props.row.oldFee && props.row.oldFee != props.row.fee"> <del>{{ formatMoney(props.row.oldFee) }}</del> </span>
                <span v-if="!props.row.calc && !props.row.another && !props.row.app">{{ formatMoney(props.row.fee) }}</span>
              </div>
              <div v-else>
                <span v-if="!props.row.calc && !props.row.another && !props.row.app">{{ formatMoney(props.row.fee) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="inflow ? 'Institute Surcharge' : ''" :width="175" align="right">
            <template slot-scope="props">
              <div v-if="$store.state.accreditationEnabled">
                <span v-if="!props.row.calc && !props.row.another && !props.row.app">{{ formatMoney(props.row.surcharge) }}</span>
              </div>
              <div v-else>
                <span v-if="!props.row.calc && !props.row.another && !props.row.app">{{ formatMoney(props.row.surcharge) }}</span>
                <span v-else-if="!props.row.exact && !props.row.another && !props.row.app">{{ props.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="$store.state.accreditationEnabled" :label="inflow ? 'Institute Accreditation' : ''" :width="175" align="right">
            <template slot-scope="props">
              <span v-if="!props.row.calc && !props.row.another && !props.row.app">{{ props.row.accreditation ? formatMoney(props.row.accreditation) : '-----'}}</span>
              <span v-else-if="!props.row.exact && !props.row.another && !props.row.app">{{ props.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Total" :width="200" align="right">
            <template slot-scope="props">
              <span v-if="props.row.app">{{ props.row.value }}</span>
              <span v-else-if="!props.row.calc && !props.row.another">{{ formatMoney(props.row.fee + props.row.surcharge + props.row.accreditation) }}</span>
              <span v-else-if="props.row.exact && !props.row.another">
                <el-tooltip class="item" :manual="true" :value="showCurrentCreditPopovers" effect="light"
                  content="Set extra credit to 0 in order to use your current credit" placement="left">
                  <el-input-number class="pull-right" v-model="toBuy" :min="min" :max="1000"></el-input-number>
                </el-tooltip>
              </span>
              <span v-else-if="props.row.curr">
                <el-popover ref="currentCreditPopover" placement="left" trigger="hover" :disabled="true"
                  @show="showCurrentCreditPopovers = true" @hide="showCurrentCreditPopovers = false" content="">
                </el-popover>
                <el-tooltip class="item" :manual="true" :value="showCurrentCreditPopovers" effect="light"
                  content="Current credit is not used when purchasing extra credit" placement="left">
                  <span v-show="toBuy > 0" v-popover:currentCreditPopover
                    class="btn btn-simple btn-xs btn-danger btn-icon" style="z-index: 1000"><i
                      class="fa fa-question"></i></span>
                </el-tooltip>
                <span :class="{ strikeThrough: toBuy > 0 }">{{ props.row.value }}</span>
              </span>
              <span v-else>
                {{ props.row.value }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <button v-if="multi && inflow && !inview && credit" @click.prevent="$emit('editMulti')" type="button"
          style="margin-bottom: 10px" class="btn btn-sm">
          <i class="fa fa-pencil"></i> Edit verifications</button><br />
        <button v-if="canAdd && inflow && !inview && credit" @click.prevent="$emit('newVerification')" type="button"
          class="btn btn-sm">
          <i class="fa fa-plus"></i> Add another verification
        </button>
      </div>
    </div>

    <transition name="el-fade-in-linear" mode="out-in">
      <div v-if="!nothingToPay" v-loading="loadingBt || paying" element-loading-spinner="qc-spinner" class="col-sm-12 card">
        <div class="card-header">
          <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon"
            v-if="this.accountCountry == 'Nigeria'">
            <span data-notify="icon" class="fa fa-exclamation"></span>
            <span data-notify="message" style="font-size: 130%">
              As your account is registered in Nigeria, please be aware of the following: locally issued Nigerian payment cards are currently
              limited in the amount they can transact via international payments. Where possible please use a non-Naira currency card or
              debit/credit card enabled for international transactions. If you have trouble making payment please try a different card(s).
            </span>
          </div>
          <h4 class="card-title">Payment Details</h4>
          <div class="category">
            Your credit or debit card details to pay for this order
          </div>
        </div>

        <div class="card-content row">
          <div v-loading="nothingToPay" element-loading-spinner="fa fa-check fa-3x"
            element-loading-text="Nothing to pay!" class="form-group">
            <div v-if="isStripe" class="col-sm-12">
              <div v-if="stripe.confirmed" class="alert alert-success">
                <template v-if="stripe.landed">Your payment has been added to your account credit. Press the button below to continue, or change your order first.</template>
                <template v-else>Your payment has been received. If this page does not move on, press the button below to continue.</template>
              </div>
              <div v-show="!stripe.confirmed">
                <!-- Stripe requires the currency selector to be shown to use Adaptive Pricing, directly above the Payment Element -->
                <div id="stripe-currency-selector" />
                <div id="stripe-payment-element" />
              </div>
              <div v-if="stripe.error" class="alert alert-danger">{{ stripe.error }}</div>
            </div>
            <!-- Hidden (not removed) until GET /credit says which provider this is: Braintree's container has to exist for its setup, and a Stripe payer must not see its form flash up first -->
            <div v-else v-show="provider" class="col-sm-12">
              <div id="dropin-container" />
              <p-checkbox class="pull-right" v-model="btSaveCard">Save card for later</p-checkbox>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div class="col-md-12 card card-plain">
      <!-- While a Stripe payment is in play, a full-screen mask (see showPayMask) keeps the payer on this view -->
      <button v-if="inflow" @click.prevent="$emit('payBack')" type="button" class="btn btn-wd btn-move-left">
        <span class="btn-label"><i class="ti-angle-left"></i></span>Back
      </button>
      <button @click.prevent="getBtNonce('pay')" type="button" v-bind:disabled="payDisabled"
        v-bind:class="{ 'btn-disabled': payDisabled }" class="btn btn-wd btn-fill btn-move-right pull-right">
        {{ nothingToPay ? "Next" : "Pay" }}<span class="btn-label"><i class="ti-angle-right"></i></span>
      </button>

      <button v-if="inflow && inview" @click.prevent="$emit('deleteVerification')" type="button" class="btn btn-wd">
        <i class="fa fa-trash"></i> Delete
      </button>
      <span v-if="inflow && inview" class="help-block">Completely delete this verification request as it is no longer
        needed.</span>
    </div>
  </div>
</template>

<script>
import accounting from "accounting";
import _ from 'lodash';
import { Loading } from 'element-ui';
import LogRocket from 'logrocket'
import {version} from '../../../../package.json';
import axios from '../../../../src/http'

accounting.settings.currency.symbol = "£";

// Same release channel as the API version the server's stripe-java is pinned to
const STRIPE_JS_URL = "https://js.stripe.com/dahlia/stripe.js";
const CURRENCY_SYMBOLS = { GBP: "£", EUR: "€", USD: "$" };
// How often, and for how long, to look for a charged payment in the account's credit after the follow-up call failed (2 minutes)
const PAYMENT_WATCH_INTERVAL_MS = 4000;
const PAYMENT_WATCH_CHECKS = 30;

// Stripe.js is only loaded for Stripe users, never for everyone from index.html
let stripeJsPromise = null;
function loadStripeJs() {
  if (window.Stripe) {
    return Promise.resolve(window.Stripe);
  }
  if (!stripeJsPromise) {
    stripeJsPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = STRIPE_JS_URL;
      script.onload = () => (window.Stripe ? resolve(window.Stripe) : reject(new Error("Stripe.js did not load")));
      script.onerror = () => {
        stripeJsPromise = null;
        reject(new Error("Stripe.js failed to load"));
      };
      document.head.appendChild(script);
    });
  }
  return stripeJsPromise;
}

export default {
  name: "payment",

  props: {
    application: { type: Object, default: null },
    verifications: { type: Array, default: null },
    min: { type: Number, default: 1 },
    inflow: { type: Boolean, default: false },
    inview: { type: Boolean, default: false },
    multi: { type: Boolean, default: false },
    // Optional, asked before a Stripe card is charged (Braintree validates before it charges, because the server does the charging): resolves true if the
    // parent's form is valid. Without it a payer with an invalid form is charged first and told afterwards.
    validate: { type: Function, default: null },
  },
  data() {
    return {
      loading: true,
      loadingBt: true,
      paying: false,
      toBuy: this.inflow ? 0 : 10,
      credit: null,
      vatPayer: false,
      btInstance: null,
      btNonce: null,
      btSaveCard: true,
      nothingToPay: false,
      showCurrentCreditPopovers: false,
      accountCountry: "",
      newFee: false,
      provider: null, // BRAINTREE or STRIPE, from GET /credit
      stripe: {
        sessionId: null,
        total: null, // the session's own formatted total, in the currency the payer chose
        canConfirm: false,
        confirmed: false, // the card has been charged, whatever the follow-up call goes on to do
        confirmedSessionId: null, // the session that was charged and the amount it was for, kept for re-sending after a failed follow-up call
        confirmedAmount: null,
        sessionTotal: null, // what the server will add as credit for the current session, in the account currency
        confirmedTotal: null, // the same, for the session that was charged
        creditBefore: null, // the account's credit just before the charge, to tell when the payment has been added to it
        landed: false, // the charged payment now shows in the account's credit, so leaving the pay view is safe again
        stale: false, // the amount or basket changed while a payment was in flight, so the session needs rebuilding if it does not go through
        error: null,
      },
    };
  },
  created() {
    // Stripe's objects are kept out of Vue's reactivity on purpose
    this.stripeRuntime = { token: 0, checkout: null, actions: null, elements: [] };
    // One timer per component: a debounce shared through the methods object is shared by every Payment on the page and outlives this one
    this.reSetup = _.debounce(() => this.setup(), 500);
    this.paymentWatch = null; // the timer looking for a charged payment in the credit, see watchForPayment
    this.payMask = null; // the full-screen mask that keeps the payer on this view while a Stripe payment is in play, see showPayMask
  },
  beforeDestroy() {
    this.reSetup.cancel(); // a call still pending would run setup() on a destroyed component and create an orphan Stripe session
    this.stopWatchingForPayment();
    this.hidePayMask();
    this.stripeRuntime.token++;
    this.teardownStripe();
  },
  computed: {
    isStripe() {
      return this.provider === "STRIPE";
    },
    // Only Stripe users get their account currency's symbol, Braintree users are unchanged
    moneySymbol() {
      return this.isStripe ? CURRENCY_SYMBOLS[this.$store.state.currency] || "£" : undefined;
    },
    // Everything the server prices a session from, besides the amount, compared by value (a parent may pass a fresh array on every render, which must
    // not recreate the session): which institutes, in which order (the price can depend on the position), whether accreditation is added (it is a
    // separate charge), and the application (its pricing scheme).
    basketKey() {
      const applicationId = this.application ? this.application.id : "";
      return (this.verifications || [])
        .map((verification) => (verification.institute ? verification.institute.id : "") + (verification.accreditation ? "+accreditation" : ""))
        .join("|") + "@" + applicationId;
    },
    payDisabled() {
      if (this.loadingBt || this.paying) {
        return true;
      }
      return this.isStripe && !this.nothingToPay && !this.stripe.confirmed && !this.stripe.canConfirm;
    },
    displayTotal() {
      const total = this.totalToPay; // Always evaluated, it also works out nothingToPay
      return this.isStripe && this.stripe.total ? this.stripe.total : total;
    },
    canAdd() {
      return !(this.application && this.application.lockedInstitutes);
    },
    canRemove() {
      return !(this.application && this.application.lockedInstitutes);
    },
    items() {
      var items = [];

      if (this.verifications) {
        this.verifications.forEach((verification, index) => {
          var instituteNames = null;
          if (this.$service.isEmp(verification.institute)) {
            instituteNames = [{ name: verification.institute.fields[0].value }];
            // } else if(this.$service.isHSC(verification.institute)) {
            //   instituteNames = [{name: verification.institute.fields[0].value}]
          } else {
            instituteNames =
              verification.institute.names &&
                verification.institute.names.length > 0
                ? verification.institute.names
                : [{ name: verification.institute.name }];
          }
          items.push({
            candidateName: verification.firstname + " " + verification.lastname,
            instituteNames: instituteNames,
            calc: false,
            oldFee: this.$store.state.hasDiscount ? this.$store.getters.preSalePrice(this.getVerificationPrice(verification, index)) : null,
            fee: this.getVerificationPrice(verification, index),
            surcharge: verification.institute.surcharge,
            accreditation: verification.accreditation ? verification.institute.accreditation : null
          });
        });
      }

      // if(this.application) {
      //     items.push({
      //       name: this.application.name,
      //       owner: this.application.owner.name,
      //       app: true,
      //       value: 'FREE'
      //     })
      // }

      // if(this.inflow) {
      //   items.push({
      //     another: true
      //   })
      // }

      if (!this.inflow) {
        items.push({
          name: this.inflow ? "Extra credit" : "Exact credit",
          exact: true,
          calc: true,
          min: this.min,
        });
      }

      if (
        this.inflow &&
        this.verifications &&
        this.verifications.length > 1 &&
        (this.vatPayer || accounting.unformat(this.credit) > 0)
      ) {
        items.push({
          name: "Sub total",
          calc: true,
          value: this.total,
        });
      }

      if (this.vatPayer) {
        items.push({
          name: "Plus VAT",
          calc: true,
          value: this.vat,
        });
      }

      if (this.inflow && accounting.unformat(this.credit) > 0) {
        items.push({
          name: "Less current credit",
          calc: true,
          curr: true,
          value: "(" + this.credit + ")",
        });
      }

      if (
        this.isStripe || // Stripe requires its session total to be displayed, in the currency the payer chose
        this.vatPayer ||
        (this.verifications && this.verifications.length > 1) ||
        (this.inflow && accounting.unformat(this.credit) > 0) ||
        !this.inflow
      ) {
        items.push({
          // The rows above are in the account currency, Stripe's total is in the payer's chosen one, so say what it is
          name: this.isStripe ? "You pay" : "Total",
          calc: true,
          value: this.displayTotal,
        });
      }

      return items;
    },
    verificationTotal() {
      let sumTotal = 0;
      if (this.verifications) {
        this.verifications.forEach((verification, index) => {
          if (verification.institute) {
            sumTotal += (this.getVerificationPrice(verification, index) + verification.institute.surcharge + (verification.accreditation ? verification.institute.accreditation : 0));
          }
        });
      }
      return sumTotal;
    },
    total() {
      return this.money(this.toBuy + this.verificationTotal);
    },
    vat() {
      return this.money(
        accounting.unformat(this.total) * (this.vatPayer ? 0.2 : 0)
      );
    },
    totalToPay() {
      var toPay =
        accounting.unformat(this.total) +
        accounting.unformat(this.vat) -
        (this.inflow && this.toBuy <= 0 ? accounting.unformat(this.credit) : 0);
      this.nothingToPay = toPay <= 0;
      return this.money(toPay > 0 ? toPay : 0);
    },
  },
  mounted() {
    this.setup();
    this.$api
      .getAccount()
      .then((response) => {
        this.accountData = response.data;
        this.accountCountry = this.accountData.company.addressCountry.name;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  watch: {
    toBuy(value) {
      if (!value) {
        this.toBuy = 1;
      }
      this.sessionInputsChanged(true);
    },
    basketKey() {
      this.sessionInputsChanged(false);
    },
  },
  methods: {
    getVerificationPrice(verification, index) {
      if (this.application && this.application.pricingScheme) {
        var scheme = this.application.pricingScheme
        var list = scheme[verification.institute.regionId]
        if(list == null) list = scheme[verification.institute.id]
        if(list == null) list = scheme['default']
        return this.getVerificationPriceFromList(list, index)
      } else {
        return verification.institute.product.price
      }
    },
    getVerificationPriceFromList(list, index) {
      if (list[index]) {
          return list[index];
        } else {
          return list[list.length - 1];
        }
    },
    formatMoney(value) {
      return this.money(value);
    },
    money(value) {
      return accounting.formatMoney(value, this.moneySymbol);
    },
    // The amount or the basket changed. A Stripe session is for a fixed amount, so it has to be recreated; Braintree takes its amount when the nonce is
    // charged, so only an amount change re-runs its setup, as before.
    sessionInputsChanged(amountChanged) {
      if (!this.isStripe) {
        if (amountChanged) {
          this.reSetup();
        }
        return;
      }
      if (this.paying || this.stripe.confirmed) {
        // Mid-confirm, or already charged: that session is the one in play. Swapping in another now could leave the payer with an unpaid second session,
        // and a second charge for the same order.
        if (!this.stripe.confirmed) {
          this.stripe.stale = true;
        }
        return;
      }
      // Pay goes off from this instant and not when the debounce fires, so the old session cannot be confirmed for the new amount
      this.stripe.canConfirm = false;
      this.loadingBt = true;
      this.reSetup();
    },
    rebuildIfBasketChanged() {
      if (this.stripe.stale) {
        this.stripe.stale = false;
        this.reSetup();
      }
    },
    refreshCredit() {
      return this.$api.getCreditInfo(true).then((response) => {
        this.credit = this.money(response.data.credit);
        this.checkPaymentLanded(response.data.credit);
      }).catch((error) => console.warn(error));
    },
    // The charged payment has landed once the credit has grown by what the session adds, whichever of the API and the webhook recorded it.
    // Compared with the credit from just before the charge, because credit the account already held could be more than the payment by itself.
    checkPaymentLanded(credit) {
      if (!this.stripe.confirmed || this.stripe.landed || this.stripe.confirmedTotal == null || this.stripe.creditBefore == null) {
        return;
      }
      if (Number(credit) - this.stripe.creditBefore >= this.stripe.confirmedTotal - 0.005) {
        this.stripe.landed = true;
        this.stopWatchingForPayment();
        this.hidePayMask();
        this.$snotify.info("Your payment has been added to your account credit, please try submitting again.", "Payment Recorded", { timeout: 10000 });
      }
    },
    // After a charge whose follow-up call failed, the webhook can record the payment a little later, so keep checking for a while.
    // If it still has not shown up after that, something is wrong with recording it: let the payer go, and tell them not to pay again.
    watchForPayment() {
      if (this.paymentWatch || this.stripe.landed) {
        return;
      }
      let checks = 0;
      const next = () => {
        this.paymentWatch = setTimeout(() => {
          checks++;
          this.refreshCredit().then(() => {
            if (!this.paymentWatch || this.stripe.landed) {
              return;
            }
            if (checks < PAYMENT_WATCH_CHECKS) {
              next();
              return;
            }
            this.paymentWatch = null;
            this.hidePayMask();
            this.stripe.error = "Your payment was received but we have not been able to record it yet. Please do not pay again: refresh this page in a few minutes, " +
              "and contact us if it is not in your account credit by then.";
          });
        }, PAYMENT_WATCH_INTERVAL_MS);
      };
      next();
    },
    stopWatchingForPayment() {
      if (this.paymentWatch) {
        clearTimeout(this.paymentWatch);
        this.paymentWatch = null;
      }
    },
    // A Stripe payment is in play from the moment the card is confirmed until it is either declined, submitted, or recorded as credit. Leaving the
    // pay view in that time destroys this component, and with it the session being paid: coming back before the payment is recorded would start a
    // new full-price session, and a second charge. So the whole screen is masked for that time, the same full-screen loading the parents use for
    // their submission. That one is a singleton, so a parent's "Submitting verification(s)" reuses this mask and closes it when it finishes.
    showPayMask(text) {
      const mask = Loading.service({ fullscreen: true, lock: true, spinner: "qc-spinner", text });
      mask.setText(text); // a mask already showing is returned as it is
      this.payMask = mask;
    },
    hidePayMask() {
      if (this.payMask && this.payMask.visible) {
        this.payMask.close();
      }
      this.payMask = null;
    },
    setup() {
      this.loadingBt = true
      var _this = this;
      this.$api
        .getCreditInfo()
        .then((response) => {
          this.provider = response.data.paymentProvider || "BRAINTREE";
          this.credit = this.money(response.data.credit);
          this.btToken = response.data.btToken;
          this.vatPayer = response.data.vatPayer;
          this.totalToPay;
          if (this.isStripe) {
            this.setupStripe();
            this.paying = false;
            return;
          }
          if (!this.nothingToPay) {
            if (typeof braintree !== 'undefined') {
            braintree.dropin.create(
              {
                authorization: this.btToken,
                vaultManager: true,
                container: "#dropin-container",
                threeDSecure: true,
                paypal: this.$store.state.currency != 'GBP' ? null : {
                  flow: 'checkout',
                  amount: ''+ accounting.unformat(this.totalToPay),
                  currency: 'GBP'
                },
                googlePay: this.$store.state.currency != 'GBP' ? null : {
                  googlePayVersion: 2,
                  merchantId: 'BCR2DN6T56O63DIW',
                  transactionInfo: {
                    totalPriceStatus: 'FINAL',
                    totalPrice: ''+ accounting.unformat(this.totalToPay),
                    currencyCode: 'GBP',
                    countryCode: 'GB'
                  },
                  allowedPaymentMethods: [{
                    type: 'CARD',
                    parameters: {
                      // We recommend collecting and passing billing address information with all Google Pay transactions as a best practice.
                      billingAddressRequired: true,
                      billingAddressParameters: {
                        format: 'FULL'
                      }
                    }
                  }]
                }
              },
              function (createErr, instance) {
                if (createErr) {
                  if (createErr.message == "options.selector or options.container must reference a valid DOM node.") {
                    console.warn(createErr);
                  } else {
                    console.error(createErr);
                  }
                  _this.loading = false;
                  _this.loadingBt = false
                } else {
                  _this.btInstance = instance;
                  _this.btInstance.on('paymentMethodRequestable', function (event) {
                    if (event.type == 'AndroidPayCard' && event.paymentMethodIsSelected && !_this.paying) {
                      // The customer has completed the flow and we are ready to submit the payment method nonce to the server.
                      _this.getBtNonce('pay')
                    }
                  })
                  document.querySelector(
                    'div[data-braintree-id="postal-code-field-group"] > label > div[class="braintree-form__label"]'
                  ).innerHTML = "Postal Code / Zip Code";
                  _this.loading = false;
                  _this.loadingBt = false
                }
              }
            );
            } else {
              var logRocketEnv = null
                logRocketEnv = 'selective'
                LogRocket.init('omhnj3/qc-prod', {
                  release: version
                })
              axios.get('https://js.braintreegateway.com/web/dropin/1.32.0/js/dropin.min.js')
                .then(response => {
                  console.log(response.data);
                })
                .catch(error => {
                  this.$snotify.warning("Braintree, the third party which is used to process payments, has failed. Please try clearing your cache and then repeating payment. If the error persists please contact Qualification Check.", "Warning", {
                  timeout: 10000,
                  })
                  LogRocket.captureMessage('BRAINTREE FETCH FAIL', {
                    tags: {
                      // additional data to be grouped as "tags"
                      code: 'BFF',
                    },
                    extra: {
                      // additional arbitrary data associated with the event
                      page: 'Checkout',
                    },
                  });
                  console.log(error);
                });
            }
          } else {
            this.loading = false;
            this.loadingBt = false
          }

          this.paying = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    stripeSessionRequest() {
      const applicationId = this.application ? this.application.id : null;
      return {
        // Same as the parent submits, minus the uploaded documents which have no bearing on the price
        verifications: (this.verifications || []).map((verification) => {
          const built = this.$service.buildVerificationSubmission(verification, applicationId);
          built.documents = [];
          return built;
        }),
        creditPurchase: { amount: this.toBuy },
      };
    },
    teardownStripe() {
      const runtime = this.stripeRuntime;
      runtime.elements.forEach((element) => {
        try {
          element.destroy();
        } catch (e) {
          console.warn(e);
        }
      });
      runtime.elements = [];
      runtime.checkout = null;
      runtime.actions = null;
    },
    setupStripe() {
      const runtime = this.stripeRuntime;
      const token = ++runtime.token; // Anything still in flight from an earlier setup must not mount
      this.teardownStripe();
      this.stripe.error = null;
      this.stripe.canConfirm = false;
      this.stripe.total = null;
      this.stripe.stale = false;

      if (this.nothingToPay) {
        this.loading = false;
        this.loadingBt = false;
        return;
      }

      this.loadingBt = true;
      Promise.all([loadStripeJs(), this.$api.postStripeSession(this.stripeSessionRequest())])
        .then(([Stripe, response]) => {
          if (token !== runtime.token) {
            return;
          }
          const session = response.data;
          if (response.status === 204 || !session || !session.clientSecret) {
            // The server finds there is nothing to pay, so there is nothing to show
            this.nothingToPay = true;
            this.loading = false;
            this.loadingBt = false;
            return;
          }
          this.stripe.sessionId = session.sessionId;
          this.stripe.sessionTotal = session.total != null ? Number(session.total) : null;

          const checkout = Stripe(session.publishableKey).initCheckoutElementsSdk({
            clientSecret: session.clientSecret,
            adaptivePricing: { allowed: true },
          });
          checkout.on("change", (checkoutSession) => {
            if (token === runtime.token) {
              this.stripe.total = checkoutSession.total.total.amount;
              this.stripe.canConfirm = checkoutSession.canConfirm;
            }
          });
          return checkout.loadActions().then((result) => {
            if (token !== runtime.token) {
              return;
            }
            if (result.type === "error") {
              throw new Error(result.error.message);
            }
            runtime.checkout = checkout;
            runtime.actions = result.actions;
            const checkoutSession = result.actions.getSession();
            this.stripe.total = checkoutSession.total.total.amount;
            this.stripe.canConfirm = checkoutSession.canConfirm;
            this.$nextTick(() => {
              if (token !== runtime.token) {
                return;
              }
              const currencySelector = checkout.createCurrencySelectorElement();
              currencySelector.mount("#stripe-currency-selector");
              const paymentElement = checkout.createPaymentElement();
              paymentElement.mount("#stripe-payment-element");
              runtime.elements.push(currencySelector, paymentElement);
              this.loading = false;
              this.loadingBt = false;
            });
          });
        })
        .catch((error) => {
          console.error(error);
          if (token === runtime.token) {
            this.stripe.error = "Unable to load the card payment form, please refresh the page and try again.";
            this.loading = false;
            this.loadingBt = false;
          }
        });
    },
    payWithStripe(action) {
      const _this = this;
      const emitPay = function (sessionId, amount) {
        _this.$emit(action, { amount: amount, stripeSessionId: sessionId }, function (success) {
          if (!success) {
            // The card has been charged, and the API or webhook records that as credit, so the payer must not pay again
            _this.paying = false;
            if (_this.stripe.landed) {
              _this.hidePayMask();
              _this.$snotify.warning("Your payment was received, please try submitting again.", "Payment Received", { timeout: 10000 });
              return;
            }
            // Stay masked until the payment shows as credit: it may already be there, or the webhook may add it shortly
            _this.showPayMask("Your payment was received. Recording it, please wait...");
            _this.refreshCredit();
            _this.watchForPayment();
          }
        });
      };

      if (this.stripe.confirmed) {
        // Already charged, only the follow-up call failed. Send the same session again, for the amount that was charged: it records only once.
        this.showPayMask("Processing your payment...");
        emitPay(this.stripe.confirmedSessionId, this.stripe.confirmedAmount);
        return;
      }
      const actions = this.stripeRuntime.actions;
      if (!actions) {
        this.paying = false;
        return;
      }
      // What this payment is for is taken now, before confirm(): the session and the amount can be replaced while it is in flight, and what is posted
      // afterwards must be what was charged
      const sessionId = this.stripe.sessionId;
      const amount = action === "pay" ? this.toBuy : 0;
      const sessionTotal = this.stripe.sessionTotal;
      const creditBefore = accounting.unformat(this.credit);

      const charge = () => {
        this.stripe.error = null;
        this.showPayMask("Processing your payment...");
        actions.confirm({ redirect: "if_required" }).then(
          (result) => {
            if (result.type === "error") {
              // Declined or invalid. Nothing was charged and the same session can be retried on this page.
              this.stripe.error = result.error.message;
              this.paying = false;
              this.hidePayMask();
              this.rebuildIfBasketChanged();
              return;
            }
            this.stripe.confirmed = true;
            this.stripe.confirmedSessionId = sessionId;
            this.stripe.confirmedAmount = amount;
            this.stripe.confirmedTotal = sessionTotal;
            this.stripe.creditBefore = creditBefore;
            emitPay(sessionId, amount);
          },
          (error) => {
            // confirm() itself failed: the network, Stripe.js, or the elements destroyed part way. Unlike a decline, nothing says the card was not charged.
            console.error(error);
            this.stripe.error = "We could not confirm your payment. It may have gone through, so please check your receipts before trying again.";
            this.paying = false;
            this.hidePayMask();
            this.refreshCredit();
          }
        );
      };

      if (this.validate) {
        Promise.resolve(this.validate()).then(
          (valid) => {
            if (valid) {
              charge();
            } else {
              this.paying = false;
            }
          },
          (error) => {
            console.error(error);
            this.paying = false;
          }
        );
      } else {
        charge();
      }
    },
    getBtNonce(action) {
      this.paying = true;
      var _this = this;
      if (this.isStripe && !this.nothingToPay) {
        this.payWithStripe(action);
      } else if (this.nothingToPay) {
        this.$emit(action, null, function (success) {
          if (!success) {
            _this.setup();
            _this.paying = false;
          }
        });
      } else {
        this.btInstance.requestPaymentMethod(
          {
            threeDSecure: {
              amount: accounting.unformat(this.totalToPay),
              email: this.$store.state.username,
            },
          },
          (err, payload) => {
            if (payload && payload.nonce) {
              this.$emit(
                action,
                {
                  amount: action === "pay" ? _this.toBuy : 0,
                  btNonce: payload.nonce,
                  btSaveCard: _this.btSaveCard,
                },
                function (success) {
                  if (!success) {
                    _this.setup();
                    _this.paying = false;
                  }
                }
              );
            } else {
              console.log("No BT payload or nonce returned!");
            }
            if (err) {
              console.error(err);
              _this.paying = false;
            }
          }
        );
      }
    },
  },
};
</script>

<style>
p.divider {
  display: flex;
  flex-direction: row;
}

p.divider * {
  flex-shrink: 0;
}

p.divider span.divider {
  width: 100%;
  flex-shrink: 1;
  border-bottom: 1px dotted black;
  margin: 5px;
}

.braintree-dropin label {
  width: 100%;
}

.strikeThrough {
  text-decoration: line-through;
}
</style>
